var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaundryLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 385,
    height: 509,
    viewBox: "0 0 385 509",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 5)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#E9530D",
    strokeWidth: 10,
    d: "M35 0h315c16.569 0 30 13.431 30 30v449c0 11.046-8.954 20-20 20H25c-11.046 0-20-8.954-20-20V30C5 13.431 18.431 0 35 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9530D",
    d: "M5 460h375v10H5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E9530D",
    strokeWidth: 10,
    d: "M5 97h375v23H5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9530D",
    d: "M212 45h168v10H212a5 5 0 1 1 0-10z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 10,
    x: 294,
    y: 151,
    fill: "#E9530D",
    rx: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 48,
    r: 15,
    fill: "#E9530D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 48,
    r: 15,
    fill: "#E9530D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 48,
    r: 15,
    fill: "#E9530D"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#E9530D",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.342 263.49l-3.23 72.042-.241.692a127.56 127.56 0 0 1-14.685 29.272 128.69 128.69 0 0 1-30.813 31.97C246.647 413.318 220.471 422 193 422c-70.692 0-128-57.308-128-128 0-70.692 57.308-128 128-128 59.038 0 110.007 40.302 124.165 96.781l.177.71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.013 324.419c9.812-14.275 21.782-21.412 35.91-21.412 22.902 0 28.296 25 52.175 25 23.879 0 21.905-24.517 43.658-25 21.754-.483 24.558 25.01 46.826 25.01 22.267 0 17.904-25.01 42.396-25.01 8.387 0 12.633 2.593 18.085 6.993"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(301 256)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 77,
    x: 4,
    y: 4,
    stroke: "#E9530D",
    strokeWidth: 8,
    rx: 13
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 40,
    x: 4,
    y: 4,
    stroke: "#E9530D",
    strokeWidth: 8,
    rx: 13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 24,
    r: 5,
    fill: "#E9530D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 61,
    r: 5,
    fill: "#E9530D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaundryLine);
export default __webpack_public_path__ + "static/media/laundry-line.802e6e3a88f8f15c175a0809b9476005.svg";
export { ForwardRef as ReactComponent };